import React, {Component} from 'react';
import AuctionPromotionItem from '../AuctionPromotionItem';
import {ListContainer, NotHasMore, NoData} from './style';
import {observer} from "mobx-react";
import {InfiniteLoader} from '@jdcfe/yep-react';
import noDataImg from '../../../assets/image/no_data.png';
import unit_institution from "../../../store/asset_institution/unit_institution";
import unit_institution_promotion from "../../../store/asset_institution/unit_institution_promotion";

@observer
class AuctionList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: null,
    }
  }

  componentDidMount() {
  }


  onScroll = (e) => {
  }

  loadMore = () => {
    const {isLoadNext} = this.props
    if(isLoadNext===false){
      return
    }
    const {getPromotionAuctionList} = this.props.store;
    if (unit_institution.curTabIndex === 2) {
      getPromotionAuctionList(unit_institution_promotion.vendorId);
    }
  }

  render() {
    const {promotionAuctionList, promotionListHasMore} = this.props.store;
    return (
      <div>
        {unit_institution.curTabIndex === 2 &&
        <ListContainer style={{ paddingBottom: '0.6rem' }}>
          {promotionAuctionList && promotionAuctionList.length !== 0 && (<InfiniteLoader
            dataLength={promotionAuctionList.length}
            hasMore={promotionListHasMore}
            onScroll={(e) => {
              this.onScroll(e);
            }}
            loadMore={() => {
              this.loadMore();
            }}
          >
            {promotionAuctionList.length !== 0 && promotionAuctionList.map(
              value => (<AuctionPromotionItem
                key={value.id}
                itemInfo={value}
              ></AuctionPromotionItem>))
            }
            {
              promotionAuctionList.length !== 0 && !promotionListHasMore &&
              (
                <NotHasMore>
                  没有更多啦~
                </NotHasMore>
              )
            }
          </InfiniteLoader>)}

          {
            promotionAuctionList.length === 0 && !promotionListHasMore &&
            (
              <NoData>
                <img src={noDataImg} alt=""/>
                <p>暂无符合条件的推介，去看看其他推介吧~</p>
              </NoData>
            )
          }
          {
            promotionAuctionList.length === 0 && promotionListHasMore &&
            (
              <NoData>
              </NoData>
            )
          }
        </ListContainer>
        }
      </div>
    )
  }
}

export default AuctionList;
